import { Navigate } from 'react-router-dom';
import { accountService } from '../../_services/accounts.service';

export function AuthRoute(params: {
    element: JSX.Element
}): JSX.Element {

    const currentUser = accountService.currentUserValue;

    if (!currentUser || !currentUser.token || !currentUser.roles || !currentUser.roles.length) {
        return <Navigate to="/login" replace />;
    }

    return (params.element);
};

export default AuthRoute;